module.exports = __webpack_public_path__ + "assets/media/rocket.d66b2589.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rocket.svg
// module id = 1061
// module chunks = 0